import React from "react";
import "./CustomTable.css"
import { useRef } from"react"
import ImgDownload from "../images/Image_download.png";
import ExcelImg from "../images/excel.png";
import * as XLSX from 'xlsx'
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';

function CustomTable({data}) {

  const tableRef = useRef(null);

  const handleImgDownload = () => {
    html2canvas(tableRef.current).then((canvas) => {
      canvas.toBlob((blob) => {
        saveAs(blob, 'table.png');
      });
    });
  };


  const handleDownload = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "data.xlsx");
  };

  if(data.length !== 0) {
    return (
      <div>
      
          <nav className="navbar navbar-expand-sm" id = "buttons-nav">
              <ul className ="navbar-nav ml-auto">
                  <li className="nav-item">
                      <button onClick = {handleImgDownload} className="navbar-brand buttons" >
                          <img src= {ImgDownload} width="20" height="20" alt="Download"  border = "0" />
                      </button>
                  </li>
                  <li className="nav-item">
                      <button onClick = {handleDownload} className="navbar-brand buttons" >
                          <img src= {ExcelImg} width="20" height="20" alt="Download Excel"/>
                      </button>
                  </li>
              </ul>
          </nav>
        

      
        <div>
          <table className = "table" ref={tableRef}>
            <thead>
              <tr>
                {Object.keys(data[0]).map((column) => (
                  <th className = "firstRow" score = "col" key={column}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  {Object.values(row).map((cell, index) => (
                    <td key={index}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      );
    }else {
      return <h2>There is no data for these specific selections.</h2>
    }

    };

export default CustomTable;


